export default "data:video/mp2t;base64,ZXhwb3J0IHR5cGUgc3NvRW5hYmxlZCA9IHsKICBzc286IGJvb2xlYW47CiAgcHJvdG9jb2w6IHN0cmluZzsKfTsK"